import React, {useEffect, useState} from "react";
import {DebouncedInput} from "../../components/DebouncedInput";
import {motion} from "motion/react";
import {httpsCallable} from "firebase/functions";
import {functions} from "../../firebase";
import {useSearchParams} from "react-router-dom";

type AtlasJsonData = {
    species: string;
    genus: string;
    family: string;
    gram: string;
    genusGroupLevel: string;
    speciesLevel: string;
    subspeciesLevel: string;
    oxygen: string;
}

const searchBacteriaPreparation = httpsCallable<{ query: string, limit?: number }, AtlasJsonData[]>(functions,"searchBacteriaPreparation")


export const SamplePreparationSearch: React.FC = () => {
    const [query, setQuery] = useState<string>('');
    const [results, setResults] = useState<AtlasJsonData[]>([]);
    const [isLoadingSearch, setIsLoadingSearch] = useState<boolean>(false);
    const [ searchParams ] = useSearchParams();

    useEffect(() => {
        if( searchParams.has('query')) {
            const initialQuery = searchParams.get('query') || '';
            setQuery(initialQuery);
        }
    }, []);

    useEffect(() => {
        const timeout = setTimeout(() => {
            if (!query) setResults([]);

            setIsLoadingSearch(true);
            searchBacteriaPreparation({ query, limit: 20 })
                .then((result) => {
                    setResults(result.data);
                })
                .catch((error) =>
                    console.error('Error searching:', error))
                .finally(() => setIsLoadingSearch(false));
        }, 100); // adjust delay if needed

        return () => clearTimeout(timeout);
    }, [query]);


    return (
        <div className="sample-preparation-search container">
            <h1>Sample Preparation</h1>
            <div className="row">
                <div className="col-4 mb-20">
                    <DebouncedInput
                        value={query}
                        onDebouncedChange={setQuery}
                        placeholder="Search for species, genus, family..."
                        className="form-control"
                        autoFocus
                    />
                </div>
        <div className="col-12">
            <div className="d-none d-lg-block order-list-results__header bg-primary py-20 px-30">
                <div className="row">
                    <div className="col-12">
                        <div className="row">
                            <div className="col-3">
                                <strong className="text-black">Species</strong>
                            </div>
                            <div className="col-1">
                                <strong className="text-black">Gram</strong>
                            </div>
                                    <div className="col-2">
                                        <strong className="text-black">Genus / Group Level</strong>
                                    </div>
                                    <div className="col-2">
                                        <strong className="text-black">Species Level</strong>
                                    </div>
                                    <div className="col-2">
                                        <strong className="text-black">Subspecies Level</strong>
                                    </div>
                                    <div className="col-2">
                                        <strong className="text-black">Oxygen</strong>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {isLoadingSearch && (
                <div className="row mt-20">
                    <div className="col-12">
                        <div className="text-center py-20">
                            <div
                                className="spinner-border text-primary"
                                role="status"
                            >
                                <span className="visually-hidden">Loading...</span>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {!isLoadingSearch && results.length > 0 && results.map(({
                                                                        family,
                                                                        species,
                                                    gram,
                                                    genusGroupLevel,
                                                    speciesLevel,
                                                    subspeciesLevel,
                                                    oxygen
                                                }, i) => (
                <motion.div
                    initial={{
                        opacity: 0,
                        y: 10
                    }}
                    animate={{
                        opacity: 1,
                        y: 0
                    }}
                    transition={{duration: 0.1, delay: i * 0.03}}
                    className="col-12" key={i}>
                    <div className="order-list-results__wrapper bg-white">
                        <div className="row gy-20">
                            <div className="col-12">
                                <div className="d-flex flex-column justify-content-center h-100">
                                    <div className="row">
                                        <div className="col-12 col-sm-6 col-lg-3">
                                        <span>
                                          <span className="d-block d-lg-none fw-bold">
                                            Species:
                                          </span>
                                           <span>
                                              <span className="d-block">{family}</span>
                                              <span className="d-block">{species}</span>
                                            </span>
                                        </span>
                                        </div>
                                        <div className="col-12 col-sm-6 col-lg-1">
                                            <span>
                                              <span className="d-block d-lg-none fw-bold">
                                                Gram:
                                              </span>
                                                {gram}
                                            </span>
                                        </div>
                                        <div className="col-12 col-sm-6 col-lg-2">
                                            <span>
                                              <span className="d-block d-lg-none fw-bold">
                                                Genus / Group Level:
                                              </span>
                                                {genusGroupLevel}
                                            </span>
                                        </div>
                                        <div className="col-12 col-sm-6 col-lg-2">
                                            <span>
                                              <span className="d-block d-lg-none fw-bold">
                                                Species Level:
                                              </span>
                                                {speciesLevel}
                                            </span>
                                        </div>
                                        <div className="col-12 col-sm-6 col-lg-2">
                                            <span>
                                              <span className="d-block d-lg-none fw-bold">
                                                Subspecies Level:
                                              </span>
                                                {subspeciesLevel}
                                            </span>
                                        </div>
                                        <div className="col-12 col-sm-6 col-lg-2">
                                            <span>
                                              <span className="d-block d-lg-none fw-bold">
                                                Oxygen:
                                              </span>
                                                {oxygen || "-"}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </motion.div>
            ))}
        </div>
    );
}